"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getParentRouteByRole = function (url, role) {
    var pathPrefix = '';
    if (role === 'superAdmin')
        pathPrefix = '/admin';
    else if (role === 'manager')
        pathPrefix = '/manager';
    var parentRoute = "".concat(pathPrefix).concat(url);
    return parentRoute;
};
exports.default = getParentRouteByRole;
